// Facts about the Flowstep MCP server that every /mcp page quotes.
// Keep these in sync with apps/api/src/rest-router/mcp/. The marketing pages
// publish install commands verbatim, so a drift here ships a broken command.

import { MCP_TOOLS } from "@flowstepdesign/shared";

export const MCP_SERVER_URL = "https://api.flowstep.ai/mcp";
export const MCP_DOCS_URL = "https://docs.flowstep.ai/mcp/overview";
export const MCP_TRANSPORT = "Streamable HTTP";

/** docs.flowstep.ai setup page for one client; slugs match ours. */
export const mcpClientDocsUrl = (slug: string) =>
  `https://docs.flowstep.ai/mcp/clients/${slug}`;

type McpToolGroup = {
  name: string;
  /** What this group of tools is for, in one line. */
  summary: string;
  tools: (typeof MCP_TOOLS)[keyof typeof MCP_TOOLS][];
};

export const MCP_TOOL_GROUPS: McpToolGroup[] = [
  {
    name: "Generate and edit designs",
    summary:
      "AI tools that generate and edit screens, plus your messages left.",
    tools: [
      MCP_TOOLS.aiDesignScreens,
      MCP_TOOLS.aiGenerateScreenVariant,
      MCP_TOOLS.aiEditScreenVariant,
      MCP_TOOLS.getPlanDetails,
    ],
  },
  {
    name: "Read and manage screens",
    summary: "How the agent sees and manages screens on the canvas.",
    tools: [
      MCP_TOOLS.listScreens,
      MCP_TOOLS.getScreenImage,
      MCP_TOOLS.getScreenJsx,
      MCP_TOOLS.addScreenJsx,
      MCP_TOOLS.replaceScreenJsx,
      MCP_TOOLS.renameScreen,
      MCP_TOOLS.deleteScreen,
      MCP_TOOLS.getChatHistory,
    ],
  },
  {
    name: "Manage files",
    summary: "Project housekeeping without switching to the browser.",
    tools: [
      MCP_TOOLS.listFiles,
      MCP_TOOLS.getFile,
      MCP_TOOLS.createFile,
      MCP_TOOLS.updateFile,
      MCP_TOOLS.deleteFile,
    ],
  },
  {
    name: "Keep output on-brand",
    summary:
      "File instructions are markdown stored on a file and sent with every generation made against it.",
    tools: [
      MCP_TOOLS.getFileInstructions,
      MCP_TOOLS.updateFileInstructions,
      MCP_TOOLS.deleteFileInstructions,
    ],
  },
  {
    name: "Bring in your own material",
    summary: "Reference images, PRDs, and existing Figma frames.",
    tools: [MCP_TOOLS.uploadAttachment, MCP_TOOLS.importFigma],
  },
];

export const MCP_TOOL_COUNT = MCP_TOOL_GROUPS.reduce(
  (total, group) => total + group.tools.length,
  0,
);

console.assert(
  MCP_TOOL_COUNT === Object.keys(MCP_TOOLS).length,
  "MCP_TOOL_COUNT should match MCP_TOOLS count",
);
